module.exports = __webpack_public_path__ + "media/assets/partners/space_next_door-4c81edf6979b0196a15599586ab18323.svg";